// src/types/wordbook.ts
export enum Visibility {
    VISIBLE = 'VISIBLE',
    HIDDEN = 'HIDDEN',
}

export interface Wordbook {
    id: number;
    ownerId: number | null;
    ownerName: string | null;
    groupId: number | null;
    groupTitle: string | null;
    libraryId: number | null;
    title: string;
    headLang: string;
    meaningLang: string;
    totalWords: number;
    visibility: Visibility;
    thumbnailUrl: string | null;
    groupSortOrder: number;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface WordbookDetail extends Wordbook {
    ownerEmail: string | null;
    words: WordInfo[] | null;
}

export interface WordInfo {
    id: number;
    dictId: number | null;
    wordLang: string;
    wordText: string;
    meaningLang: string;
    meaningText: string;
    difficultyBase: number | null;
    sortOrder: number;
    createdAt: string;
    deletedAt: string | null;
    magicCard?: WordMagicCardInfo;
    pos?: string | null;
    phonetic?: string | null;
    dictionaryInfo?: WordDictionaryInfo | null;
}

export interface WordDictionaryInfo {
    id: number;
    word: string;
    languageCode: string;
    pos: string | null;
    translation: string | null;
    translationLang: string | null;
    phonetic: string | null;
    difficultyScore: number | null;
    aiProvider: string | null;
    sourceType: string | null;
    hitCount: number;
    updatedAt: string;
}

export type MagicCardUserStatus = 'READY' | 'QUEUED' | 'GENERATING' | 'FAILED';

export interface WordMagicCardInfo {
    userStatus: MagicCardUserStatus | null;
    userGeneratedAt: string | null;
    userSourceVersion: number | null;
    userDeletedAt: string | null;
    userCreatedAt: string | null;
    userUpdatedAt: string | null;
    cacheExists: boolean;
    cacheSummaryJson: string | null;
    cacheProvider: string | null;
    cacheModelName: string | null;
    cachePromptVersion: string | null;
    cacheVersion: number | null;
    cacheHitCount: number | null;
    cacheUpdatedAt: string | null;
}
